// Páginas visitadas na sessão (caminho + query), mais recente primeiro. A
// barra lateral usa para voltar a uma área onde a pessoa estava — o board, a
// aba, o filtro na URL — em vez da raiz. sessionStorage: some ao fechar a aba.

const VISITS_KEY = 'sophia:recentVisits';
const MAX_VISITS = 40;

export function rememberVisit(url: string): void {
  try {
    const pathname = url.split('?')[0];
    const visits = recentVisits().filter((v) => v.split('?')[0] !== pathname);
    visits.unshift(url);
    sessionStorage.setItem(VISITS_KEY, JSON.stringify(visits.slice(0, MAX_VISITS)));
  } catch { /* ignora */ }
}

export function recentVisits(): string[] {
  try {
    const raw = sessionStorage.getItem(VISITS_KEY);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
}
